module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home":{"hooks.onAddedToDom":[{"value":function() {
if (fox.site.showSplash) {
var splash = fox.site.embedWidget('splash', 'Splash');
splash.activate();
splash.run();
var players = fox.site.wom('~.Content_Html5Player');
players.forEach(function (player, i) {
player.setOption('html5PlayerConfig.movie.autoplay', false);
})
}
require('../components/valentines-gifts-popup')(fox);
this.embedWidget('valentinesGiftsPopup', 'ValentinesGiftsPopup').run();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"@root #home","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/splash.opt
// module id = 681
// module chunks = 4